<div class="app-container">
  <!-- Header Navigation -->
  <header class="main-header">
    <div class="brand-header" (click)="router.navigate(['/home'])" style="cursor: pointer;">
      <img src="/Docsila_logo.png" alt="DocSila" class="brand-logo-header">
    </div>
    
    <!-- Data Extraction Tabs (only show on table view - first page) -->
    <div class="eval-tabs" *ngIf="viewMode === 'table'">
      <button 
        class="eval-tab" 
        [class.active]="activeExtractionTab === 'configuration'" 
        (click)="setExtractionTab('configuration')">
        Data Extraction Configuration
      </button>
      <button 
        class="eval-tab" 
        [class.active]="activeExtractionTab === 'inference'" 
        (click)="setExtractionTab('inference')">
        Data Extraction Inference
      </button>
    </div>

    <!-- Navigation Buttons in Header -->
    <div class="header-nav-buttons">
      <!-- Role Badge -->
      @if (authService.isAdmin) {
        <span class="role-badge admin-badge" [title]="authService.getUserRoleAndEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
          </svg>
          <span>{{ authService.getUsernameFromEmail() }}</span>
        </span>
      } @else {
        <span class="role-badge user-badge" [title]="authService.getUserRoleAndEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span>{{ authService.getUsernameFromEmail() }}</span>
        </span>
      }
      
      <button class="header-nav-btn" (click)="navigateToSequencing()" title="Sequencing">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <line x1="10" y1="6" x2="21" y2="6"></line>
          <line x1="10" y1="12" x2="21" y2="12"></line>
          <line x1="10" y1="18" x2="21" y2="18"></line>
          <path d="M4 6h1v4"></path>
          <path d="M4 10h2"></path>
          <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"></path>
        </svg>
      </button>
      <button class="header-nav-btn active" title="Data Extraction">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      </button>
      <button class="header-nav-btn" (click)="navigateToVersioning()" title="Versioning">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <line x1="6" y1="3" x2="6" y2="15"></line>
          <circle cx="18" cy="6" r="3"></circle>
          <circle cx="6" cy="18" r="3"></circle>
          <path d="M18 9a9 9 0 0 1-9 9"></path>
        </svg>
      </button>
      <button class="header-nav-btn" (click)="navigateToTruthManagement()" title="External Mapping">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      </button>
      <button class="header-nav-btn" (click)="navigateToExtractionEval()" title="Eval">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
          <polyline points="9 11 12 14 22 4"></polyline>
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
        </svg>
      </button>
      
      <!-- Login/Logout Button (Last) -->
      @if (isAuthenticated) {
        <button class="header-nav-btn" (click)="logout()" title="Logout">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      } @else {
        <button class="header-nav-btn" (click)="router.navigate(['/login'])" title="Login">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
            <polyline points="10 17 15 12 10 7"></polyline>
            <line x1="15" y1="12" x2="3" y2="12"></line>
          </svg>
        </button>
      }
    </div>
  </header>

  <!-- Table View (Landing Page) -->
  <main class="main-content" *ngIf="viewMode === 'table'">
    <!-- Toolbar -->
    <div class="toolbar">
      <div class="toolbar-spacer"></div>
      <div class="toolbar-actions">
        <button class="btn-new-item" (click)="openNewDocDialog()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          New Item
        </button>
      </div>
    </div>

    <!-- Documents Table -->
    <div class="table-wrapper">
      @if (extractionDocuments.length > 0) {
        <table class="documents-table">
          <colgroup>
            <col style="width: 20%">
            <col style="width: 18%">
            <col style="width: 15%">
            <col style="width: 12%">
            <col style="width: 12%">
            <col style="width: 13%">
            <col style="width: 10%">
          </colgroup>
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Document Type</th>
              <th>Document Code</th>
              <th>Attributes</th>
              <th>Samples</th>
              <th>Added Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (doc of extractionDocuments; track doc.id) {
              <tr class="data-row" (dblclick)="onRowDoubleClick(doc)">
                <td>
                  <div class="title-cell">
                    <span class="doc-name">{{ doc.documentName }}</span>
                  </div>
                </td>
                <td>
                  <div class="type-cell">
                    <span class="doc-type">{{ doc.documentType }}</span>
                  </div>
                </td>
                <td>
                  <div class="code-cell">
                    <span class="doc-code">{{ doc.documentCode }}</span>
                  </div>
                </td>
                <td>
                  <div class="count-cell">
                    <span class="count-value">{{ doc.attributes }}</span>
                  </div>
                </td>
                <td>
                  <div class="count-cell">
                    <span class="count-value">{{ doc.samples }}</span>
                  </div>
                </td>
                <td>
                  <div class="date-cell">
                    <span class="date-value">{{ doc.addedDate | date:'MMM d, yyyy' }}</span>
                  </div>
                </td>
                <td>
                  <div class="status-cell">
                    <span class="status-badge" [class]="'status-' + doc.status.toLowerCase()">
                      {{ doc.status }}
                    </span>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

      @if (extractionDocuments.length === 0) {
        <div class="empty-table-state">
          <svg class="empty-icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
          </svg>
          <p class="empty-title">No documents found</p>
          <p class="empty-subtitle">Click "New Item" to add your first document</p>
        </div>
      }
    </div>
  </main>

  <!-- Data Extraction Configuration Tab Content -->
  <main class="content-grid" *ngIf="viewMode === 'configuration' && activeExtractionTab === 'configuration'">
    
    <!-- Column 1: Sample Selection -->
    <section class="column sample-column">
      <div class="card">
        <div class="card-title-with-back">
          <h2 class="card-title">Document Type</h2>
          <button class="btn-back" (click)="backToTable()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Back
          </button>
        </div>
        
        <div class="sample-counter">
          <span class="counter-text">{{ currentSampleIndex + 1 }}/{{ totalSamples }} Samples</span>
        </div>

        <div class="sample-list" *ngIf="samples.length > 0">
          <div *ngFor="let sample of samples; let i = index" 
               class="sample-item"
               [class.active]="selectedSample?.id === sample.id"
               (click)="selectSample(sample, i)">
            <div class="sample-info">
              <svg class="sample-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <div class="sample-details">
                <span class="sample-name">{{ sample.name }}</span>
                <span class="sample-pages">Pages {{ sample.pageRange }}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="samples.length === 0" class="empty-state">
          <p>No samples available</p>
          <p class="empty-state-hint">Complete sequencing to create samples</p>
        </div>
      </div>
    </section>

    <!-- Column 2: PDF Viewer -->
    <section class="column viewer-column">
      <div class="card viewer-card">
        <div class="viewer-header-inline">
          <h2 class="card-title">Document Preview</h2>
          <div class="viewer-controls-inline">
            <div class="page-controls">
              <button class="control-btn" (click)="previousPage()" [disabled]="!pdfSrc || currentPage === 1" title="Previous Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <span class="page-counter">{{ pdfSrc ? currentPage + '/' + totalPages : '0/0' }}</span>
              <button class="control-btn" (click)="nextPage()" [disabled]="!pdfSrc || currentPage === totalPages" title="Next Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
            <div class="zoom-controls">
              <button class="control-btn" (click)="zoomOut()" [disabled]="!pdfSrc || zoom <= 0.5" title="Zoom Out">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <span class="zoom-level">{{ (zoom * 100) | number:'1.0-0' }}%</span>
              <button class="control-btn" (click)="zoomIn()" [disabled]="!pdfSrc || zoom >= 3.0" title="Zoom In">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="11" y1="8" x2="11" y2="14"></line>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="pdf-container">
          @if (!pdfSrc) {
            <div class="empty-state">
              <svg class="empty-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <p>No document loaded</p>
              <p class="empty-subtitle">Select a sample to preview</p>
            </div>
          }

          @if (pdfSrc) {
            <pdf-viewer 
              [src]="pdfSrc" 
              [render-text]="true"
              [original-size]="false"
              [show-all]="false"
              [page]="currentPage"
              [zoom]="zoom"
              (after-load-complete)="onPdfLoadComplete($event)"
              style="width: 100%; height: 100%;"
            ></pdf-viewer>
          }
        </div>
      </div>
    </section>

    <!-- Column 3: Data Extraction Configuration -->
    <section class="column config-column">
      <div class="card">
        <h2 class="card-title">Data Extraction Configuration</h2>

        <div class="config-form">
          <div class="form-group">
            <label for="selectKey">Select Key</label>
            <select 
              id="selectKey" 
              class="form-select" 
              [(ngModel)]="selectedAttributeId"
              [disabled]="!selectedSample">
              <option [value]="null" disabled selected>Select key</option>
              <option *ngFor="let attr of attributes" [value]="attr.id">
                {{ attr.attributeLabel }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="selectDataType">Select Datatype</label>
            <select 
              id="selectDataType" 
              class="form-select" 
              [(ngModel)]="selectedDataType"
              [disabled]="!selectedSample">
              <option value="" disabled selected>Select datatype</option>
              <option *ngFor="let type of dataTypes" [value]="type">
                {{ type }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="extractionPrompt">Extraction Prompt</label>
            <textarea 
              id="extractionPrompt" 
              class="form-textarea" 
              rows="6"
              [(ngModel)]="extractionPrompt"
              [disabled]="!selectedSample"
              placeholder="Enter extraction instructions...">
            </textarea>
          </div>

          <div class="form-actions">
            <button 
              class="btn-save" 
              (click)="saveConfiguration()"
              [disabled]="!selectedSample || !selectedAttributeId || !selectedDataType || !extractionPrompt.trim() || isSaving">
              <svg *ngIf="!isSaving" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                <polyline points="7 3 7 8 15 8"></polyline>
              </svg>
              <span *ngIf="!isSaving">Save</span>
              <span *ngIf="isSaving">Saving...</span>
            </button>
          </div>
        </div>
      </div>
    </section>

  </main>

  <!-- Data Extraction Inference Tab Content -->
  <main class="inference-container" *ngIf="viewMode === 'configuration' && activeExtractionTab === 'inference'">
    <!-- Toolbar -->
    <div class="inference-toolbar">
      <div class="toolbar-actions">
        <button class="btn-new-item" (click)="openNewItemDialog()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          New Item
        </button>
      </div>
    </div>

    <!-- Inference Runs Table -->
    <div class="inference-table-wrapper">
      <table class="inference-table">
        <colgroup>
          <col style="width: 25%;">
          <col style="width: 20%;">
          <col style="width: 12%;">
          <col style="width: 18%;">
          <col style="width: 12%;">
          <col style="width: 13%;">
        </colgroup>
        <thead>
          <tr>
            <th>
              <div class="th-with-search">
                <span>Run Title</span>
                <div class="search-bar-compact">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                  </svg>
                  <input 
                    type="text" 
                    class="search-input" 
                    placeholder="Search..."
                    [(ngModel)]="inferenceSearchQuery"
                    (input)="filterInferenceRuns()">
                  @if (inferenceSearchQuery) {
                    <button class="clear-search" (click)="clearInferenceSearch()" title="Clear search">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  }
                </div>
              </div>
            </th>
            <th>
              <div class="th-with-filter">
                <span>Document Type</span>
                <select class="filter-dropdown" [(ngModel)]="selectedDocTypeFilter" (change)="filterInferenceRuns()">
                  <option value="">All</option>
                  <option value="DTSAUSDU">DTSAUSDU</option>
                  <option value="DTUSAUSDU">DTUSAUSDU</option>
                  <option value="DTSAUSCA">DTSAUSCA</option>
                  <option value="DTUSAUSCA">DTUSAUSCA</option>
                </select>
              </div>
            </th>
            <th>Samples</th>
            <th>Time of Run</th>
            <th>Progress</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @if (filteredInferenceRuns.length === 0 && inferenceSearchQuery) {
            <tr class="empty-row">
              <td colspan="6">
                <div class="empty-state">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                  </svg>
                  <p>No results found for "{{ inferenceSearchQuery }}"</p>
                </div>
              </td>
            </tr>
          }
          @if (filteredInferenceRuns.length === 0 && !inferenceSearchQuery) {
            <tr class="empty-row">
              <td colspan="6">
                <div class="empty-state">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                  </svg>
                  <p>No inference runs yet. Click "New Item" to start.</p>
                </div>
              </td>
            </tr>
          }
          @for (run of filteredInferenceRuns; track run.id) {
            <tr class="data-row" 
                (dblclick)="run.status === 'Completed' && navigateToInferenceResults(run.id)"
                [style.cursor]="run.status === 'Completed' ? 'pointer' : 'default'">
              <td>
                <span class="run-title">{{ run.documentTitle || 'Untitled Run' }}</span>
              </td>
              <td>
                <div class="document-cell">
                  <span class="document-type">{{ run.documentType }}</span>
                  <span class="file-name">{{ run.fileName }}</span>
                </div>
              </td>
              <td>
                <div class="samples-cell">
                  <span class="samples-count">{{ run.samples }}</span>
                </div>
              </td>
              <td>
                <div class="time-cell">
                  <span class="run-date">{{ run.timeOfRun | date: 'MMM d, yyyy' }}</span>
                  <span class="run-time">{{ run.timeOfRun | date: 'h:mm a' }}</span>
                </div>
              </td>
              <td>
                <div class="progress-cell">
                  <div class="circular-progress">
                    <svg class="progress-ring" width="40" height="40">
                      <circle class="progress-ring-circle-bg" cx="20" cy="20" r="16" />
                      <circle class="progress-ring-circle" cx="20" cy="20" r="16" 
                              [style.stroke-dashoffset]="100.5 - (100.5 * run.progress / 100)" />
                    </svg>
                    <span class="progress-percentage">{{ run.progress }}%</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="status-cell">
                  <span class="status-badge" [class]="'status-' + run.status.toLowerCase()">
                    {{ run.status }}
                  </span>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </main>

  <!-- New Document Dialog (for table view) -->
  @if (showNewDocDialog) {
    <div class="dialog-overlay" (click)="closeNewDocDialog()">
      <div class="dialog-content" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3>New Document</h3>
          <button class="btn-close" (click)="closeNewDocDialog()">×</button>
        </div>
        
        <div class="dialog-body">
          <div class="form-group">
            <label class="form-label">Document Name</label>
            <input 
              type="text" 
              class="form-control" 
              [(ngModel)]="newDoc.documentName"
              placeholder="Enter document name"
              maxlength="100">
          </div>

          <div class="form-group">
            <label class="form-label">Document Type</label>
            <input 
              type="text" 
              class="form-control" 
              [(ngModel)]="newDoc.documentType"
              placeholder="Enter document type"
              maxlength="100">
          </div>

          <div class="form-group">
            <label class="form-label">Document Code</label>
            <input 
              type="text" 
              class="form-control" 
              [(ngModel)]="newDoc.documentCode"
              placeholder="Enter document code"
              maxlength="50">
          </div>
        </div>

        <div class="dialog-footer">
          <button class="btn-secondary" (click)="closeNewDocDialog()">Cancel</button>
          <button class="btn-primary" (click)="addNewDocument()" 
                  [disabled]="!newDoc.documentName || !newDoc.documentType || !newDoc.documentCode">
            Add Document
          </button>
        </div>
      </div>
    </div>
  }

  <!-- New Item Dialog -->
  @if (showNewItemDialog) {
    <div class="dialog-overlay" (click)="closeNewItemDialog()">
      <div class="dialog-content" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3>New Inference Run</h3>
          <button class="btn-close" (click)="closeNewItemDialog()">×</button>
        </div>
        
        <div class="dialog-body">
          <div class="form-group">
            <label class="form-label">Document Type</label>
            <select class="form-control" [(ngModel)]="selectedDocType">
              <option value="">Select Document Type</option>
              <option value="DTSAUSDU">DTSAUSDU</option>
              <option value="DTUSAUSDU">DTUSAUSDU</option>
              <option value="DTSAUSCA">DTSAUSCA</option>
              <option value="DTUSAUSCA">DTUSAUSCA</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Run Title</label>
            <input 
              type="text" 
              class="form-control" 
              [(ngModel)]="documentTitle"
              placeholder="Enter a descriptive title for this document"
              maxlength="100">
          </div>

          <div class="form-group">
            <label class="form-label">Model</label>
            <select class="form-control" [(ngModel)]="selectedModel">
              <option value="">Select Model</option>
              <option value="GPT-4">GPT-4</option>
              <option value="Claude 3">Claude 3</option>
              <option value="Gemini Pro">Gemini Pro</option>
              <option value="Model A">Model A</option>
              <option value="Model B">Model B</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Upload File</label>
            <input 
              type="file" 
              #fileInputInference
              (change)="onFileSelected($event)" 
              accept=".pdf" 
              style="display: none">
            <button *ngIf="!authService.isReadOnly" class="btn-upload" (click)="fileInputInference.click()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              {{ selectedFile ? selectedFile.name : 'Choose File' }}
            </button>
            @if (selectedFile) {
              <p class="file-info">{{ (selectedFile.size / 1024).toFixed(2) }} KB</p>
            }
          </div>
        </div>

        <div class="dialog-footer">
          <button class="btn-secondary" (click)="closeNewItemDialog()">Cancel</button>
          <button class="btn-primary" (click)="executeRun()" 
                  [disabled]="!selectedDocType || !documentTitle || !selectedModel || !selectedFile || isRunning || authService.isReadOnly">
            {{ isRunning ? 'Running...' : 'Run' }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
